export default `
mutation getGoogleToken($token: String!) {
  googleSignIn(token: $token) {
    status
    token
  }
}
`;
